module.exports = __webpack_public_path__ + "static/media/flipV.79d5836c.svg";